import { ca } from '@cian/analytics';

export const trackSelfEmployedSwitcherShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'New_ad',
    action: 'selfemployed_show',
  });
};

export const trackSelfEmployedSwitcherClick = (label: 'selfemployed' | 'non_selfemployed') => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'New_ad',
    action: 'selfemployed_select',
    label,
  });
};
